/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */

const getFieldBaseName = name => name.split('[')[0].replace('._error', '');

export default getFieldBaseName;
